import { FC } from "react";
import { cn } from "@/libs/utils";
import { useTrans } from "src/utils/useTrans";
import DownloadIcon from "@/v2-components/core/icon/download-icon";

type Props = {
  className?: string;
  label?: string;
};

const Download: FC<Props> = ({ className = "", label = "Download File" }) => {
  const { t } = useTrans(["gnb"]);

  return (
    <div
      className={cn(
        "flex h-full w-full flex-grow cursor-pointer items-center justify-between border border-black p-3.5",
        "max-h-[54px] max-w-[270px]",
        "hover:bg-black hover:[&_*]:text-white",
      )}
    >
      <span
        className={
          "flex-grow whitespace-pre text-sm font-700 leading-[1.93] text-[#222222]"
        }
      >
        {t(`${label}`)}
      </span>
      <DownloadIcon />
    </div>
  );
};

export default Download;
